import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '@/types/general';
export const Globe = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M42.326 16c-2.344-5.341-6.958-9.469-12.615-11.159C31.479 7.606 32.719 11.61 33.396 16H42.326zM43.363 29C43.777 27.401 44 25.727 44 24s-.223-3.401-.637-5h-9.6C33.918 20.655 34 22.334 34 24s-.082 3.345-.237 5H43.363zM14 24c0-1.666.082-3.345.237-5h-9.6C4.223 20.599 4 22.273 4 24s.223 3.401.637 5h9.6C14.082 27.345 14 25.666 14 24zM31 24c0-1.744-.095-3.41-.252-5H17.252C17.095 20.59 17 22.256 17 24s.095 3.41.252 5h13.496C30.905 27.41 31 25.744 31 24zM30.362 16C29.164 8.792 26.473 4 24 4s-5.164 4.792-6.362 12H30.362zM17.638 32c1.198 7.208 3.89 12 6.362 12s5.164-4.792 6.362-12H17.638zM14.604 16c.677-4.39 1.917-8.394 3.685-11.159C12.632 6.531 8.018 10.659 5.674 16H14.604zM33.396 32c-.677 4.39-1.917 8.394-3.685 11.159 5.657-1.69 10.271-5.817 12.615-11.159H33.396zM5.674 32c2.344 5.341 6.958 9.469 12.615 11.159C16.521 40.394 15.281 36.39 14.604 32H5.674z" fillOpacity="0.4" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.className) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48" fill="currentColor" className={props.className}>{t0}</svg>;
    $[1] = props.className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};